export const website = {
  firstStep: {
    title: "Iniziamo! Quale template vuoi usare?",
    subtitle:
      "Pronto a creare un sito web straordinario? Iniziamo dai template; poi passeremo ai colori.",
  },
  secondStep: {
    title: "Quale gamma di colori si adatta meglio al tuo brand?",
    subtitle: "Personalizza il tuo template con un tocco di colore",
  },
  thirdStep: {
    title: "Hai delle belle foto della tua struttura?",
    titleLine2: "Caricale!",
    subtitle: "Carica la foto migliore della tua struttura per la homepage",
  },
  fourthStep: {
    title: "Perfetto. Che ne dici di un nome per la tua attività?",
    subtitle:
      "Il nome e lo slogan di un'azienda aumentano la riconoscibilità e rafforzano l'immagine del tuo brand.",
  },
  fifthStep: {
    title: "Hai un logo per il tuo brand?",
    subtitle:
      "Per risultati ottimali, usa un disegno vettoriale o un PNG con sfondo trasparente. Le proporzioni ideali sono 2:1 o 1:1 (immagine quadrata). Le dimensioni dovrebbero essere 400px x 192px (altezza min. 60px). Se non hai ancora un logo, useremo il nome della tua attività come brand.",
  },
  livingstone: {
    navMain: "Menu principale",
    navProperty: "Struttura",
    navMap: "Mappa",
    navGallery: "Galleria",
    navRates: "Tariffe",
    navAvailability: "Disponibilità",
    navReviews: "Recensioni",
    bookNow: "Prenota ora",
    checkinCheckout: "Arrivo → Partenza",
    guests: "Ospiti",
  },
  tideway: {
    navMain: "Menu principale",
    navProperty: "Struttura",
    navMap: "Mappa",
    navGallery: "Galleria",
    navRates: "Tariffe",
    navAvailability: "Disponibilità",
    navReviews: "Recensioni",
    bookNow: "Prenota ora",
    checkinCheckout: "Arrivo → Partenza",
    guests: "Ospiti",
  },
};
